__turbopack_context__.v({
  "className": "lora_6c2aca3-module__yWV0gW__className",
});
